import { render, staticRenderFns } from "./PurchasedPlan.vue?vue&type=template&id=20efdc27&scoped=true"
import script from "./PurchasedPlan.vue?vue&type=script&lang=js"
export * from "./PurchasedPlan.vue?vue&type=script&lang=js"
import style0 from "./PurchasedPlan.vue?vue&type=style&index=0&id=20efdc27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20efdc27",
  null
  
)

export default component.exports